import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: {
      permissionList: [],
      realName: "",
      username: "",
    },
  },
  getters: {},
  mutations: {
    SET_USER_INFO(state, info) {
      state.userInfo = Object.assign({}, this.userInfo, info);
    },
  },
  actions: {},
  modules: {},
});
